module.exports = __webpack_public_path__ + "img/register.af62fa8a.svg";